export const NOT_FOUND = 'CARD-NOT-FOUND-404'
export const CAPTCHA_REQUIRED = 'CAPTCHA_REQUIRED'
export const INVALID_CAPTCHA = 'INVALID-CAPTCHA-400'
